import React from 'react';
import { useSystemEmailTemplatesWrap } from '../hooks/use-system-email-templates-wrap.js';
import SystemEmailTemplatesWrapPageView from './system-email-templates-wrap-page-view.jsx';

function SystemEmailTemplatesWrapPageContainer() {
  const state = useSystemEmailTemplatesWrap();
  return <SystemEmailTemplatesWrapPageView {...state} />;
}

export default SystemEmailTemplatesWrapPageContainer;
